import { assertWritableSemester, makeId, rosterFor } from "./core.mjs";

function cleanName(value, label) {
  const text = String(value ?? "").trim();
  if (!text || text.length > 100) throw new Error(`${label}必须是 1 到 100 字的纯文本`);
  return text;
}

function timestamp(value = new Date().toISOString()) {
  if (typeof value !== "string" || !Number.isFinite(Date.parse(value))) throw new Error("时间必须是有效日期时间");
  return value;
}

function createPersonRecord(id, now) {
  return { id, createdAt: now, updatedAt: now, teachingTip: "", tags: [], watchlisted: false };
}

export function createPersonForStudent(data, student, { personId = makeId("person"), now = new Date().toISOString() } = {}) {
  if (data.people.some((item) => item.id === personId)) throw new Error("personId 已存在");
  const record = createPersonRecord(personId, timestamp(now));
  student.personId = personId;
  data.people.push(record);
  return personId;
}

export function addRosterStudents(data, { semesterId, classId, students, personIdFactory = () => makeId("person"), now = new Date().toISOString() }) {
  assertWritableSemester(data, semesterId);
  const roster = rosterFor(data, semesterId, classId);
  if (!roster) throw new Error("学期班级名单不存在");
  if (!Array.isArray(students) || !students.length) throw new Error("没有可加入的学生");
  const safeTime = timestamp(now);
  const existingStudentIds = new Set(data.semesterRosters.flatMap((item) => item.students.map((student) => student.id)));
  const existingPersonIds = new Set(data.people.map((item) => item.id));
  const existingNos = new Set(roster.students.map((item) => item.studentNo).filter(Boolean));
  const prepared = students.map((input, index) => {
    const id = String(input.id || makeId("stu")).trim();
    const name = cleanName(input.name, `第 ${index + 1} 行姓名`);
    const studentNo = String(input.studentNo ?? "").trim();
    const personId = String(personIdFactory(input, index)).trim();
    if (!id || existingStudentIds.has(id)) throw new Error(`学生 id 重复：${id || "空"}`);
    if (!personId || existingPersonIds.has(personId)) throw new Error(`personId 重复：${personId || "空"}`);
    if (studentNo && existingNos.has(studentNo)) throw new Error(`学号 ${studentNo} 在班级内重复`);
    existingStudentIds.add(id); existingPersonIds.add(personId); if (studentNo) existingNos.add(studentNo);
    return { student: { id, studentNo, name, personId }, profile: createPersonRecord(personId, safeTime) };
  });
  roster.students.push(...prepared.map((item) => item.student));
  data.people.push(...prepared.map((item) => item.profile));
  return prepared.map((item) => item.student);
}
